import styled from 'styled-components';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0 27px 0 3px;
  height: 100%;
  gap: 30px;
  overflow: hidden;
`;
Wrapper.displayName = 'Wrapper';

export default Wrapper;
